/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slot_HiddenInputs */

const en_slot_hidden = /** @type {(inputs: Slot_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidden`)
};

const de_slot_hidden = /** @type {(inputs: Slot_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgeblendet`)
};

/**
* | output |
* | --- |
* | "Hidden" |
*
* @param {Slot_HiddenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slot_hidden = /** @type {((inputs?: Slot_HiddenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slot_HiddenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_slot_hidden(inputs)
	return en_slot_hidden(inputs)
});